import { Phone, Mail } from "lucide-react";
import { CONTACT } from "@/data/services";

/** Feste mobile CTA-Leiste (nur auf kleinen Screens sichtbar) */
export default function MobileCTA() {
  return (
    <div
      className="fixed bottom-0 inset-x-0 z-50 md:hidden bg-[#122B18]/95 backdrop-blur border-t border-[#1E5631] px-3 py-2.5 flex gap-2.5 shadow-2xl"
      data-testid="mobile-cta-bar"
    >
      <a
        href={CONTACT.phoneHref}
        data-testid="mobile-cta-call-button"
        className="flex-1 inline-flex items-center justify-center gap-2 bg-[#3D8B4D] active:bg-[#4AA05C] text-white font-bold py-3 rounded-lg text-sm"
      >
        <Phone className="w-4 h-4" /> Anrufen
      </a>
      <a
        href={CONTACT.emailHref}
        data-testid="mobile-cta-mail-button"
        className="flex-1 inline-flex items-center justify-center gap-2 bg-white text-[#1E5631] font-bold py-3 rounded-lg text-sm"
      >
        <Mail className="w-4 h-4" /> E-Mail
      </a>
    </div>
  );
}
